<template>
  <DBox :id="'cmp-booking-booking-booking_sidewindow-artists'" :addButton="false" :addLink="true"
    :addLinkLabel="`${$t('add_new_artist')}`" @add_click="addArtistClick">
    <NTable class="artist-list dbox1" :id="'booking-booking-booking_sidewindow-artists'" :headers="artistListHeader"
      :items="artists" :config="tableConfig" :showNoItems="false">
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('artist')" @click="(e) => onArtistNameClick(item)">
            <span class="ut-link ut-text-accent5">{{
              item["artist_name"]
            }}</span>
          </td>
          <td v-bind="tdcon('pfm_type')">
            <TextField2 type="text" class="dbox1" id="performance_type" :showLabel="false" :disabled="false"
              :value="item['performance_type']" :bb="'0px'" :placeholder="$t('insert_performance_type')"
              @change="(e) => onTextFieldChange(e, item)" />
          </td>
          <td v-bind="tdcon('booking_artist_status')">
            <!-- <div class="ut-flex statuscoltext">
              <div class="status_text">
              </div>
            </div> -->
            <Dropdown2 class="dbox1" :options="booking.statusesTV" :showLabel="false" :placeholder="$t('status')"
              :selected="booking.statusesTV.find(
                (s) => s.value == item['booking_status_id']
              )
                " v-on:selectedChange="(e) => onBookingArtistsStatusChange(item, e)" status :style="{
                  maxWidth: '100%',
                  width: '100%',
                }" bb="0">
            </Dropdown2>
          </td>
          <td v-bind="tdcon('first_offer')">
            <TextField2 type="text" class="dbox1" id="first_offer_notes" :showLabel="false" :disabled="false"
              :placeholder="$t('insert_offer_notes')" :value="item['first_offer_notes']" :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)" />
            <!-- <input
              type="text"
              class="ntable--textfield"
              :name="'of_notes' + item['artist_id']"
              :id="'of_notes' + item['artist_id']"
              placeholder="Insert Offer Notes..."
              :value="item['first_offer_notes']"
              v-on:blur="(e) => onTextFieldChange(e, item)"
            /> -->
          </td>
          <td v-bind="tdcon('exclusivity')">
            <div class="dt-icon-container"><img
                v-if="removeArtistExclusivityLoading == item.artist_id"
                src="static/icons/loading.gif"
                alt
                style="height: 10px; width: 10px; margin: 0px 10px"
              />
              <v-menu open-on-hover bottom left offset-y max-width="768" v-else>
                <img
                  :src="`static/icons/artist-exclusivity/artist-exclusivity-${item.exclusive_icon == 'GREEN' ? 'active' : item.exclusive_icon == 'RED' ? 'inactive' : 'gray'}.svg`"
                  class="dt-icon s1" style="cursor:auto;" slot="activator" />

                <v-card>
                  <div class="info-card-body">
                    <div v-html="exclusivityTooltip(item)" @click="handleTooltipClick"></div>
                  </div>
                </v-card>
              </v-menu>
            </div>
          </td>
          <td v-bind="tdcon('mail')" @click="onArtistOfferNoteClick(item)">
            <div class="dt-icon-container">
              <img src="static/icons/email/email-grey.svg" class="dt-icon v5 s1" :alt="$t('send_mail')"
                :title="$t('send_mail')" />
            </div>
          </td>
          <td v-bind="tdcon('close')" @click="(e) => removeArtist(item)">
            <div class="dt-icon-container" v-if="artists && artists.length > 1">
              <img src="static/icons/delete.svg" class="dt-icon v5 s1" :alt="$t('delete_artist')"
                :title="$t('delete_artist')" />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import Dropdown from "../../../../plugins/dropdown/dropdown";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import NTable from "@/plugins/datatable/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { BookingService } from "../../services/booking-service";

export default {
  components: {
    Dropdown,
    NTable,
  },
  props: ["booking"],
  data: function () {
    return {
      artistCalendarDateModalContainer: false,
      artistCalendarDateModal: false,
      removeArtistExclusivityLoading: false,

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  computed: {
    artists: function () {
      return this.booking?.artists || [];
    },
    artistListHeader: function () {
      return [
        createTableHeader("artist", {}),
        createTableHeader("pfm_type"),
        createTableHeader("booking_artist_status", {
          text: "status",
          mw: 200,
          ta: "left",
        }),
        createTableHeader("first_offer"),
        createTableHeader("exclusivity", { mw: 30, ta: "center", text: false }),
        createTableHeader("mail", { mw: 30, ta: "centert", text: false }),
        createTableHeader("close", { mw: 30, ta: "centert", text: false }),
      ];
    },
  },
  methods: {
    // onPerformanceTypeTextBoxBlur: function (e, item) {
    //   this.$emit("updated", {
    //     item,
    //     name: "performance_type",
    //     value: e.target.value,
    //   });
    // },
    onTextFieldChange: function (e, item) {
      console.log(item);
      this.$emit("updated", {
        item,
        name: e.name,
        value: e.value,
      });
    },
    onBookingArtistsStatusChange: function (item, value) {
      this.$emit("updated", {
        item,
        name: "booking_status_id",
        value: value.value,
      });
    },
    onArtistNameClick: function (artist) {
      this.$emit(
        "artist_calendar_date_selected",
        artist.calendar_date_artist_id
      );
    },
    addArtistClick: function () {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_artist_to_booking" },
      });
    },
    removeArtist: function (artist) {
      if (artist.artist_id) {
        this.$emit("deleted", artist);
      }
    },
    onArtistOfferNoteClick: function (artist) {
      openModalRoute(this, "choose_mail_template", {
        type: "artist_offer",
        artist_id: artist.artist_id,
      });
      // openModalRoute(this, "offer_mail", {
      //   artist_id: artist.artist_id,
      //   email: artist.email1,
      // });
    },
    exclusivityTooltipBkup: function (artist) {
      console.log('MDSIR Artist - ', artist);
      let tooltipText = "No exclusivity set";
      if (artist.exclusive_icon == 'GREEN') {
        const jsonData = JSON.parse(artist.json_data);
        tooltipText = `Exclusivity\n\nStart Date:\t${jsonData.start_date}\nEnd Date:\t${jsonData.end_date}\nDistance:\t${jsonData.distance} ${jsonData.unit}\nCity:\t\t${jsonData.city}\nCountry:\t${jsonData.country}\n`;
      } else if (artist.exclusive_icon == 'RED') {
        tooltipText = artist.conflict_toooltip;
      }
      return tooltipText;
    },
    exclusivityTooltip: function (artist) {
      console.log('MDSIR Artist - ', artist);
      let tooltipText = "No exclusivity set";
      if (artist.exclusive_icon == 'GREEN') {
        const jsonData = JSON.parse(artist.json_data);
        tooltipText = `Exclusivity<br><br>Start Date:&emsp;${jsonData.start_date}<br>End Date:&emsp;&nbsp;&nbsp;${jsonData.end_date}<br>Distance:&emsp;&nbsp;&nbsp;${jsonData.distance} ${jsonData.unit}<br>City:&emsp;&emsp;&emsp;&emsp;${jsonData.city}<br>Country:&emsp;&emsp;${jsonData.country}<br> <br> <div class="dt-icon-container" style="width:100%"><img data-action="delete_exclusivity" data-artist_id="${artist.artist_id}" src="static/icons/delete.svg" title="Delete exclusivity." class="dt-icon v5 s1"></div>`;
      } else if (artist.exclusive_icon == 'RED') {
        const cJsonData = JSON.parse(artist.conflict_json);
        tooltipText = `${this.$t('artist_exclusivity_conflicts_header')}<br><br>` +
          (cJsonData || []).map(b => {
            return `<a class="ut-link ut-text-sm ut-text-accent5" href="#/main/booking/booking_list/${b.calendar_date_id}/overview">
                ${b.booking_date}</a> - ${(b.venue ? b.venue + ': ' : '')}${b.city}, ${b.country}`;
          }).join('<br>');
      }
      return tooltipText;
    },
    handleTooltipClick(event) {
      if (event.target && event.target.dataset.action === 'delete_exclusivity') {
        this.exclusivityDelete(event.target.dataset.artist_id);
      }
    },
    exclusivityDelete: async function (artist_id) {
      const cda = this.artists.find(r => r.artist_id == artist_id);
      // console.log('MDSIR DEL EX ', cda);
      this.removeArtistExclusivityLoading = artist_id;
      const removed = await BookingService.removeArtistExclusivity(cda.calendar_date_artist_id);
      this.removeArtistExclusivityLoading = false;
      this.$emit('reload');
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-booking-booking_sidewindow-artists {}

.booking-booking_list-artists-status {
  display: flex;
  margin-left: -15px;

  &--color {
    margin-left: 10px;
    flex: 1;
    width: 10px;
    min-width: 10px;
    max-width: 10px;
    height: 10px;

    margin-top: auto;
    margin-bottom: auto;

    border-radius: 45px;
  }

  &--name {
    margin-left: 20px;
  }
}

.cmp-booking-booking-booking_sidewindow-artists {
  .dt-ntable {
    td {
      &.booking_artist_status {
        align-items: center;

        .statuscoltext {
          width: 100%;
        }

        .status_color,
        .status_text {
          margin-top: auto;
          margin-bottom: auto;
        }

        .status_color {
          margin: 0px 8px;

          width: 10px;
          max-width: 10px;
          height: 10px;
          border-radius: 45px;

          min-width: 10px;
        }

        .status_text {
          flex: 1;

          /* padding-left: 10px; */
          .dropdown--main__text {
            padding-right: 10px;
          }

          .dropdown {
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>
